import React from 'react';
import { styles } from './CheckboxToggleRefinement.css';

interface CheckboxToggleRefinementProps {
  label: string;
  isChecked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  count: number | undefined;
  id: string;
}

export const CheckboxToggleRefinement = ({ label, isChecked, onChange, count, id }: CheckboxToggleRefinementProps) => {
  return (
    <label className={styles.container} htmlFor={id}>
      <input
        type="checkbox"
        onChange={onChange}
        checked={isChecked}
        className={styles.checkboxInput}
        id={id}
        name={label}
      />
      {label}

      {count !== undefined && <span className={styles.labelCount}>{` (${count})`}</span>}
    </label>
  );
};
